<template>
  <div class="col-md col-xl-1 text-center" :class="classDiv">
    <span class="display-3 counter-anim" :class="classSpan">{{
      countNum
    }}</span>
    <small class="d-block">{{ countText }}</small>
  </div>
</template>

<script>
export default {
  props: {
    classDiv: {
      type: String,
      default: () => "",
    },
    classSpan: {
      type: String,
      default: () => "",
    },
    countNum: {
      type: Number,
      default: () => 0,
    },
    countText: {
      type: String,
      default: () => "",
    },
  },
};
</script>

<style>
</style>